import { isEmpty } from 'lodash';

export const PRAddressMapper = (storeAddress) => {
  if (storeAddress?.CountryCode !== 'PR') {
    return {
      address: '',
      apartmentNumber: '',
      city: '',
      zipCode: '',
    };
  }

  if (isEmpty(storeAddress?.AddressFields)) {
    return {
      address: storeAddress?.Line1 || '',
      apartmentNumber: '',
      city: storeAddress?.City || '',
      zipCode: storeAddress?.Postcode || '',
    };
  }
  return storeAddress.AddressFields;
};
